import Vue from "vue"
import { get, size } from "lodash"
import moment from "moment"
import { getSessionHistoryPage } from "@/api/user/coaching/sessionHistory"

const mapSessions = sessions =>
  sessions.map(session => {
    return {
      id: get(session, "id"),
      duration: get(session, "duration"),
      payment: get(session, "payment"),
      date: moment(get(session, "created_at")),
      game: get(session, "game_name"),
      quantity: get(session, "quantity"),
      type: get(session, "type"),
      student: {
        avatar: get(session, "student.photo"),
        name: get(session, "student.nickname"),
        id: get(session, "student.id"),
      },
    }
  })

const state = () => ({
  resultsPerPage: 0,
  totalResults: 0,
  lastPageLoaded: 0,
  sessions: {},
  reachedEndOfResults: false,
})

const mutations = {
  SET_RESULTS_PER_PAGE: (state, resultsPerPage) => {
    Vue.set(state, "resultsPerPage", resultsPerPage)
  },
  SET_TOTAL_RESULTS: (state, totalResults) => {
    Vue.set(state, "totalResults", totalResults)
  },
  SET_LAST_PAGE_LOADED: (state, page) => {
    // Only update if the page index is greater than what is stored
    if (page > state.lastPageLoaded) {
      Vue.set(state, "lastPageLoaded", page)
    }
  },
  SAVE_SESSION: (state, session) => {
    const sessionId = session.id
    Vue.set(state.sessions, sessionId, session)
  },
  SET_REACHED_END_OF_RESULTS: state => {
    Vue.set(state, "reachedEndOfResults", true)
  },
}

const actions = {
  async loadSessionHistoryPage ({ commit }, page) {
    try {
      const response = await getSessionHistoryPage(page)
      const rawSessions = get(response, "data", [])
      // Store pagination metadata
      const resultsPerPage = get(response, "per_page", 0)
      commit("SET_RESULTS_PER_PAGE", resultsPerPage)
      const totalResults = get(response, "total", 0)
      commit("SET_TOTAL_RESULTS", totalResults)
      const loadedPage = get(response, "page", 0)
      commit("SET_LAST_PAGE_LOADED", loadedPage)
      if (rawSessions.length < resultsPerPage) {
        commit("SET_REACHED_END_OF_RESULTS")
      }
      // Store transformed data from server to expected format for components
      mapSessions(rawSessions).forEach(session => {
        commit("SAVE_SESSION", session)
      })
    } catch (e) {
      console.error("Failed to load session history: ", e)
    }
  },
}

const getters = {
  getSession: state => sessionId => state.sessions[sessionId],
  getSessions: state => state.sessions,
  getResultsPerPage: state => state.resultsPerPage,
  getTotalSessions: state => state.totalResults || size(state.sessions),
  getLastPageLoaded: state => state.lastPageLoaded,
  hasReachedEndOfResults: state => state.reachedEndOfResults,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/user/coaching/sessionHistory.js